export const RECRUITER_GROUP = "Recruiter Group";
